export default "__VITE_ASSET__DwMdvpvT__"